import script from "./special.vue?vue&type=script&setup=true&lang=js"
export * from "./special.vue?vue&type=script&setup=true&lang=js"

import "./special.vue?vue&type=style&index=0&id=ca493952&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca493952"]])

export default __exports__